export const getPercent = prop => {
  if (typeof prop === 'string') {
    return prop;
  }
  if (typeof prop === 'number') {
    return `${prop}%`;
  }
  return 'auto';
};
export const getPx = prop => {
  if (typeof prop === 'string') {
    return prop;
  }
  if (typeof prop === 'number') {
    return `${prop}px`;
  }
  return 'auto';
};
export const getMs = duration => {
  if (typeof duration === 'number') {
    return `${duration}ms`;
  }
  return duration;
};

// Returns first defined argument, even if it's null or a falsy value
export const getDefined = (...args) => {
  for (let i = 0; i < args.length; i++) {
    if (args[i] !== undefined) {
      return args[i];
    }
  }
};